import { date } from 'configuration/dayjs'
import useLocalStorage from 'hooks/useLocalStorage'

interface PersistedDismissValue {
    dismiss: () => void
    isDismissed: boolean
}

const usePersistedDismiss = (
    storageKey: string,
    numberOfDaysToHideAfterDismiss?: number
): PersistedDismissValue => {
    const [persistedDismiss, setPersistedDismiss] = useLocalStorage<{
        dismissedAt?: string
    }>(`DismissableAlert:${storageKey}`, {})

    const dismiss = (): void => {
        setPersistedDismiss({ dismissedAt: date().toISOString() })
    }

    const checkDismissed = (): boolean => {
        const { dismissedAt } = persistedDismiss
        if (!dismissedAt) {
            return false
        }

        if (!numberOfDaysToHideAfterDismiss) {
            return true
        }

        const dismissedAtDate = date(dismissedAt)
        if (dismissedAtDate) {
            return date().isBefore(
                dismissedAtDate.add(numberOfDaysToHideAfterDismiss, 'days')
            )
        }

        return false
    }

    return {
        dismiss,
        isDismissed: checkDismissed(),
    }
}

export default usePersistedDismiss
